import { createAction, handleActions } from "redux-actions";

import nmhaConstants from "../../components/ui/nmha/nmhaConstants";

const actionScope = "NMHA_SESSION_";

export const nmhaSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const setMapModeRequest = createAction(actionScope + "SET_MAP_MODE_REQUEST");
export const setMapModeSuccess = createAction(actionScope + "SET_MAP_MODE_SUCCESS");

export const setGraphModeFilterRequest = createAction(
  actionScope + "SET_GRAPH_MODE_FILTER_REQUEST"
);
export const setGraphModeFilterSuccess = createAction(
  actionScope + "SET_GRAPH_MODE_FILTER_SUCCESS"
);

export const setHeatModeFilterRequest = createAction(actionScope + "SET_HEAT_MODE_FILTER_REQUEST");
export const setHeatModeFilterSuccess = createAction(actionScope + "SET_HEAT_MODE_FILTER_SUCCESS");

export const setStateModeFilterRequest = createAction(
  actionScope + "SET_STATE_MODE_FILTER_REQUEST"
);
export const setStateModeFilterSuccess = createAction(
  actionScope + "SET_STATE_MODE_FILTER_SUCCESS"
);

export const setShowClientStatesRequest = createAction(
  actionScope + "SET_SHOW_CLIENT_STATES_REQUEST"
);
export const setShowClientStatesSuccess = createAction(
  actionScope + "SET_SHOW_CLIENT_STATES_SUCCESS"
);

export const setShowZipCodesRequest = createAction(actionScope + "SET_SHOW_ZIP_CODES_REQUEST");
export const setShowZipCodesSuccess = createAction(actionScope + "SET_SHOW_ZIP_CODES_SUCCESS");

// selectors
export const mapModeSelector = state => state.nmhaSession.mapMode;
export const graphModeFilterSelector = state => state.nmhaSession.mapMode;
export const heatModeFilterSelector = state => state.nmhaSession.mapMode;
export const stateModeFilterSelector = state => state.nmhaSession.mapMode;

// initial state
const initialState = {
  mapMode: nmhaConstants.mapModes.heat,

  graphModeFilter: nmhaConstants.graphModeFilters[0],

  heatModeFilter: nmhaConstants.heatModeFilters[0],

  stateModeFilter: nmhaConstants.stateModeFilters[0],

  showClientStates: false,
  showZipCodes: false,
};

// reducers
export default handleActions(
  {
    [nmhaSessionRequestFailed]: state => state,

    [setMapModeRequest]: state => state,
    [setMapModeSuccess]: (state, { payload }) => ({
      ...state,
      mapMode: payload,
    }),

    [setGraphModeFilterRequest]: state => state,
    [setGraphModeFilterSuccess]: (state, { payload }) => ({
      ...state,
      graphModeFilter: payload,
    }),

    [setHeatModeFilterRequest]: state => state,
    [setHeatModeFilterSuccess]: (state, { payload }) => ({
      ...state,
      heatModeFilter: payload,
    }),
    [setStateModeFilterRequest]: state => state,
    [setStateModeFilterSuccess]: (state, { payload }) => ({
      ...state,
      stateModeFilter: payload,
    }),
    [setShowClientStatesRequest]: state => state,
    [setShowClientStatesSuccess]: (state, { payload }) => ({
      ...state,
      showClientStates: payload,
    }),
    [setShowZipCodesRequest]: state => state,
    [setShowZipCodesSuccess]: (state, { payload }) => ({
      ...state,
      showZipCodes: payload,
    }),
  },
  initialState
);
